import React from 'react';

import Actions from './Actions';

const columns = (refresh) => [
  {
    name: 'Name',
    selector: (row) => row.attributes.name,
    sortable: true,
  },
  {
    name: 'Action',
    sortable: false,
    width: '100px',
    cell: (row) => <Actions row={row} refresh={refresh} />,
  },
];

export default columns;
